import React, { useEffect } from "react";
import { Button, Box } from "@mui/material";
import MainHeader from "../components/header/main-header";

import LandscapeScene from "../components/bg-scene/landscape";
import MainSubheader from "../components/header/main-subheader";

import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Joseph & Achsa | Wedding";
  }, []);

  return (
    <>
        <LandscapeScene />
        <Box
          sx={{
            position: "absolute",
            top: "12%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <MainHeader hisName={"Joseph"} herName={"Achsa"} />
          <MainSubheader />

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "3rem",
              marginLeft: "0.5rem",
            }}
          >
            <Button
              onClick={() => navigate("/rsvp")}
              variant="outlined"
              sx={{
                background: "rgba(255, 255, 255, 0.8)",
                backdropFilter: "blur(10px)",
                border: "3px solid #36523c",
                padding: "0.2rem 2rem",
                fontFamily: 'serif',
                fontSize: "1.2rem",
                color: '#36523c',
                letterSpacing: "0.2rem",
                borderRadius: "8px",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  background: "rgb(240, 249, 255, 1)",
                },
                "&:active": {
                  transform: "translateY(1px)",
                },
                "@media (max-width: 600px)": {
                  width: "80%",
                  maxWidth: "300px",
                },
              }}
            >
              RSVP
            </Button>
          </Box>
        </Box>
    </>
  );
}


export default Home;
